<template>
  <div class="active_content">
    <div class="banner"></div>
    <div class="month-user">
      <!-- <p>*以充值余额时会员状态为准</p> -->
      <ul>
        <li v-for="(item, index) in state.rebateInfo" :key="index">
          <p>
            单笔充值
            <br />
            满
            <span>{{ item.money }}</span>
            元
          </p>
          <p>
            <i>{{ item.vip_money * 100 }}%</i>
            <span>赠送余额</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="no-moth">
      <img src="../../assets/webActivity/stashCoins/month_no_info.png" alt="" />
    </div>
    <!-- <div class="rebate">
      <span>本周六02:00前领取，过期自动清零</span>
      <div class="get_rebate">
        <p>
          <img src="../../assets/task/task_money_icon.png" alt="" />
          {{ state.summoney }}
        </p>
        <p @click="getCoinReward">领取</p>
      </div>
    </div> -->

    <chargeLeaderboard
      v-if="state.showWeekPay"
      :key="state.showWeekPay"
    ></chargeLeaderboard>

    <div class="go-info" v-show="state.showSkipflag" ref="btnRef">
      <p>
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Frame 427321369">
            <circle
              id="Ellipse 2209"
              cx="7"
              cy="7"
              r="6.5"
              fill="#F99A11"
              stroke="white"
            />
            <path
              id="&#239;&#188;&#129;"
              d="M6.196 2.432H7.816L7.516 8.54H6.496L6.196 2.432ZM7 9.188C7.264 9.188 7.492 9.272 7.672 9.44C7.84 9.608 7.936 9.824 7.936 10.088C7.936 10.352 7.84 10.58 7.672 10.748C7.48 10.916 7.264 11 7 11C6.736 11 6.52 10.904 6.352 10.736C6.16 10.568 6.076 10.352 6.076 10.088C6.076 9.824 6.16 9.608 6.352 9.44C6.52 9.272 6.736 9.188 7 9.188Z"
              fill="white"
            />
          </g>
        </svg>
        <span v-show="!state.isMonthCard"> 你还不是月卡用户</span>
        <span v-show="state.isMonthCard"> 当前是月卡用户</span>
      </p>
      <div class="btn-go">
        <p type="primary" @click="goMonthCard">
          <img
            src="../../assets/webActivity/stashCoins/monthCard_btn.png"
            alt=""
          />
        </p>
        <p type="primary" @click="goCashCharge">
          <img
            src="../../assets/webActivity/stashCoins/charge_btn.png"
            alt=""
          />
        </p>
      </div>
      <img
        src="../../assets/webActivity/stashCoins/recharge_info.png"
        alt=""
        class="recharge_info"
      />
    </div>
  </div>
</template>
<script setup>
import { detect } from "@/utils/device";
import { getactivityCoin, getactivityCoinReward } from "@/api/activity";
import { nextTick, onMounted, reactive, ref } from "vue";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
import { setToken } from "@/utils/auth.js";
import chargeLeaderboard from "./chargeLeaderboard.vue";

const state = reactive({
  uid: "",
  // 返利信息
  rebateInfo: [],
  // 是否月卡
  isMonthCard: false,
  // 可领取金额
  summoney: 0,
  showSkipflag: false,

  // 是否展示累冲
  showWeekPay: false,
});
var username = null;
onMounted(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  if (detect() == "android" || detect() == "harmony") {
    username = getQueryString("username");
    getQueryString("skipflag") == 1 && (state.showSkipflag = true);
  } else {
    state.showSkipflag = true;
    username = getQueryString("userId");
  }
  state.uid = getQueryString("uid");
  nextTick(() => {
    anStyle();
    getCoinInfo();
  });
});

// 获取囤币信息
const getCoinInfo = async () => {
  const res = await getactivityCoin({
    username: username,
    uid: state.uid,
  });

  console.log(res);
  if (res.data.code == 1) {
    state.rebateInfo = res.data.data.ykFanliList;
    state.isMonthCard = res.data.data.isyk;
    state.summoney = res.data.data.summoney;
    state.showWeekPay = res.data.data.showhoardCoins;
  } else {
    Toast(res.data.msg);
  }
};

// 领取
var fetchFlag = false;
const getCoinReward = async () => {
  if (!getQueryString("uid")) {
    goLogin();
    return;
  }

  if (fetchFlag) return;
  fetchFlag = true;
  const res = await getactivityCoinReward({
    username: username,
    uid: state.uid,
  });
  fetchFlag = false;
  console.log(res);
  if (res.data.code == 1) {
    state.summoney = 0;
    Toast(res.data.msg);
  } else {
    Toast(res.data.msg);
  }
  await getCoinInfo();
};
// 跳月卡
const goMonthCard = () => {
  if (detect() == "android" || detect() == "harmony") {
    window.JsBridge.skipMouthCardActivity();
  } else {
    var eventData = {
      eventType: "goMothcard",
    };
    window.parent.postMessage(eventData, "*");
  }
};
// 跳余额充值
const goCashCharge = () => {
  if (detect() == "android" || detect() == "harmony") {
    window.JsBridge.skipPtbActivity();
  } else {
    var eventData = {
      eventType: "goCashCharge",
    };
    window.parent.postMessage(eventData, "*");
  }
};

// 跳转登陆
const goLogin = () => {
  if (detect() == "android" || detect() == "harmony") {
    window.JsBridge.skipActivity(".view.my.LoginActivity");
  } else {
    Toast("请重新登录后再试～");
  }
};

// go-info
const btnRef = ref(null);

const anStyle = () => {
  if (detect() == "android" || detect() == "harmony") {
    btnRef.value.style.height = "17vh";
  }
};
</script>
<style scoped>
.active_content {
  height: 100vh;
  overflow: auto;
  position: relative;
  background-color: #09cefe;
  padding-bottom: 300px;
}
.active_content,
.banner,
.no-moth,
.rebate {
  width: 100vw;
}
.banner {
  height: 828px;
  background: url(../../assets/webActivity/stashCoins/stash-coin-bg.webp)
    no-repeat;
  background-size: 100% 100%;
}
.month-user {
  height: 482px;
  background: url(../../assets/webActivity/stashCoins/monthCard_bg.png)
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  padding: 0 56px 78px;
  margin-top: -200px;
  position: relative;
  overflow: hidden;
}
.month-user ul {
  display: flex;
  width: 100%;
  overflow: auto;
}
.month-user > p {
  position: absolute;
  bottom: 10px;
  color: red;
  font-size: 24px;
}
.month-user li {
  width: 184px;
  height: 258px;
  background: url(../../assets/webActivity/stashCoins/rebate_detail_bg.png)
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 30px 0 20px 0;
  flex-shrink: 0;
  margin-right: 20px;
}
.month-user li {
  font-weight: 800;
}
.month-user li p:nth-child(1) {
  font-size: 28px;
}
.month-user li p:nth-child(1) span {
  color: #ff6666;
}
.month-user li p:nth-child(2) {
  font-size: 20px;
  color: #fff;
}
.month-user li p:nth-child(2) i {
  font-size: 40px;
  display: block;
}

.no-moth {
  height: 266px;
  background: url(../../assets/webActivity/stashCoins/monthCard_no_bg.png)
    no-repeat;
  background-size: 100% 100%;
  margin-top: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 28px;
}
.no-moth img {
  width: 638px;
  height: 120px;
}

.rebate {
  width: 686px;
  height: 312px;
  border-radius: 30px;
  background: url(../../assets/webActivity/stashCoins/get_rebate_bg.png)
    no-repeat;
  background-size: 100% 100%;
  margin-top: 32px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 28px;
}
.rebate span {
  color: #999999;
  font-size: 24px;
  margin-bottom: 8px;
}
.rebate .get_rebate {
  height: 156px;
  width: 646px;
  background: url(../../assets/webActivity/stashCoins/rebate_bg.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
}
.rebate .get_rebate p:nth-child(1) {
  display: flex;
  align-items: center;
  color: #ff6666;
  font-size: 58px;
  font-weight: 600;
}
.rebate .get_rebate p:nth-child(1) img {
  width: 58px;
  height: 58px;
  margin-right: 8px;
}
.rebate .get_rebate p:nth-child(2) {
  width: 152px;
  height: 70px;
  text-align: center;
  line-height: 70px;
  color: #fff;
  background: linear-gradient(90deg, #ffa45e 0%, #ff5842 100%);
  border-radius: 20px 20px 20px 20px;
  font-size: 36px;
  font-weight: 600;
}
.active_content .go-info {
  height: 254px;
  width: 100vw;
  position: fixed;
  z-index: 99;
  bottom: 0;
  background: linear-gradient(180deg, #d3f8ff 0%, #ffffff 100%);
  border-radius: 60px 60px 0px 0px;
  border: 4px solid #ffffff;
  padding-top: 20px;
}
.active_content .go-info > p {
  display: flex;
  align-items: center;
  color: #2750e0;
  font-size: 24px;
  margin-bottom: 12px;
}
.active_content .go-info svg {
  width: 28px;
  height: 28px;
  margin-left: 48px;
  margin-right: 4px;
}
.active_content .go-info .recharge_info {
  width: 364px;
  height: 58px;
  position: absolute;
  right: 0;
  top: -2px;
}
.active_content .btn-go {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.active_content .btn-go img {
  width: 336px;
  height: 118px;
}
</style>
